import SearchRequests from "./SearchRequests";


const SearchPage = () => {

    return (
        <div>
            <br />
            <SearchRequests />
        </div>
    )
};

export default SearchPage;